<template>
	<main>
		<h2 class="text-center mb-6">{{message}}</h2>
		<section v-if="verified" class="vx-row justify-center lg:mt-8">
			<div class="vx-col w-full md:w-2/3 lg:w-1/3">
				<vx-card>
					<section class="flex justify-center items-center">
						<vs-button class="rounded-none m-2" type="gradient" @click.prevent="$router.push('/login')">
							Masuk ke Web ZAX
						</vs-button>
						<vs-button @click.prevent="toApp" class="rounded-none m-2" color="warning" type="gradient">
							<span class="text-dark">Masuk ke Aplikasi ZAX</span>
						</vs-button>
					</section>
				</vx-card>
			</div>
		</section>
	</main>
</template>
<script>
export default {
  data () {
    return {
      message: '',
      verified: false
    }
  },
  methods: {
    toApp() {
      window.location = process.env.VUE_APP_LINK_TO_APP
    },
    checkParam () {
      if (!this.$route.params.id) {
        this.$router.push('/')
      }
    },
    doVerify () {
      this.checkParam()

      this.$vs.loading()

      this.$store.dispatch('auth/verifyAccount', this.$route.params.id)
        .then(() => {
          this.$vs.loading.close()
          this.verified = true
          this.message = 'Selamat, akun anda berhasil diverifikasi'
        })
        .catch(e => {
          this.message = 'Link verifikasi sudah kadaluarsa'
          this.verified = false
          this.$vs.loading.close()
          if (e.response) console.error(e.response)
          this.$vs.notify({
            title: 'Oops',
            text: e.response.data.message,
            color: 'danger',
            position: 'top-right'
          })

          return false
        })
    }
  },
  created () {
    this.doVerify()
  }
}
</script>